export default {
  priceDownTitle: {
    id: 'price_change_toast_price_down_title',
    defaultMessage: 'Great news!',
  },
  priceDownDescription: {
    id: 'price_change_toast_price_down_description',
    defaultMessage: 'We found you the same {modelName} at a lower price.',
  },
  priceUpTitle: {
    id: 'price_change_toast_price_up_title',
    defaultMessage: 'Price update',
  },
  priceUpDescription: {
    id: 'price_change_toast_price_up_description',
    defaultMessage: 'See the new price for the {modelName} in your cart.',
  },
  sellerChangeTitle: {
    id: 'seller_change_toast_title',
    defaultMessage: 'Seller update',
  },
  sellerChangeDescription: {
    id: 'seller_change_toast_description',
    defaultMessage:
      'This is the same {modelName} at the same price from another seller.',
  },
  priceSellerChangeUpTitle: {
    id: 'price_seller_change_toast_price_up_title',
    defaultMessage: 'Price update',
  },
  priceSellerChangeUpDescription: {
    id: 'price_seller_change_toast_price_up_description',
    defaultMessage:
      'The seller for your {modelName} has changed. See the new price in your cart.',
  },
  priceSellerChangeDownTitle: {
    id: 'price_seller_change_toast_price_down_title',
    defaultMessage: 'Great news!',
  },
  priceSellerChangeDownDescription: {
    id: 'price_seller_change_toast_price_down_description',
    defaultMessage:
      'We found you the same {modelName} at a lower price from another seller.',
  },
} as const
